import yup from "../../../../validation/yup";
import { INVALID_EMAIL_MESSAGE, USER_EMAIL } from "../../../../validation/user";

export const validationSchema = yup.object().shape({
  email: USER_EMAIL.required(INVALID_EMAIL_MESSAGE),
});
